module.exports = __webpack_public_path__ + "static/sitting-service-8ba928b61b5aced57bae2e540aaaab97.svg";